import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import isString from 'lodash-es/isString';
import PropTypes from 'prop-types';
import React from 'react';

var styles = {"container":"panneau-field-input-group-container"};

var propTypes = {
  prepend: PropTypes.node,
  children: PropTypes.node,
  append: PropTypes.node,
  size: PropTypes.oneOf([null, 'sm', 'lg']),
  className: PropTypes.string
};
var defaultProps = {
  prepend: null,
  children: null,
  append: null,
  size: null,
  className: null
};
var InputGroupField = function InputGroupField(_ref) {
  var prepend = _ref.prepend,
    children = _ref.children,
    append = _ref.append,
    size = _ref.size,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['input-group', _defineProperty({}, "input-group-".concat(size), size !== null), styles.container, _defineProperty({}, className, className !== null)])
  }, isString(prepend) ? /*#__PURE__*/React.createElement("div", {
    className: "input-group-text"
  }, prepend) : prepend, children, isString(append) ? /*#__PURE__*/React.createElement("div", {
    className: "input-group-text"
  }, append) : append);
};
InputGroupField.propTypes = propTypes;
InputGroupField.defaultProps = defaultProps;

var definition = {
  id: 'input-group',
  component: 'InputGroup'
};

export { InputGroupField as default, definition };
